import React from 'react';
import { ExtendedInfo } from './partials/ExtendedInfo';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StateIndicator } from '../StateIndicator';

type ExtendedInfoStateIndicator = Omit<ExtendedInfo, 'helpText'> & {
  stateIndicatorStatus: StateIndicator['status'];
  helpText?: string; // override default helpText
};

export function ExtendedInfoStateIndicator({ stateIndicatorStatus, helpText, ...props }: ExtendedInfoStateIndicator) {
  const { t } = useSonTranslation('glossary');

  // in topheadlines, we use this component with a different meaning of the red and green bubbles,
  // so we need helpText to override the default meaning of draft or published
  const getHelpText = (): string => {
    if (helpText) {
      return helpText;
    }

    if (stateIndicatorStatus === 'red') {
      return t('draft');
    }

    if (stateIndicatorStatus === 'purple') {
      return t('template');
    }

    return t('published');
  };

  return (
    <ExtendedInfo modifier={props.modifier} helpText={getHelpText()} tooltipPlacement={props.tooltipPlacement}>
      <StateIndicator status={stateIndicatorStatus} modifier="no-margin-right" />
    </ExtendedInfo>
  );
}
